<template>
  <vs-sidebar
    default-index="1"
    :parent="parent"
    :hiddenBackground="$store.getters['IS_SIDEBAR_ACTIVE']"
    class="sidebarx"
    spacer
    v-model="$store.getters['IS_SIDEBAR_ACTIVE']"
    :click-not-close="$store.getters['IS_SIDEBAR_ACTIVE']"
  >
    <vs-sidebar-group title="Sentenance" open>
      <vs-sidebar-item :to="'/overview'" index="1" icon="cloud_queue">
        Overview
      </vs-sidebar-item>
      <vs-sidebar-item
        :to="'/report'"
        index="2"
        icon="description"
        v-if="this.username != 'FPSoperator'"
      >
        Report
      </vs-sidebar-item>
      <vs-sidebar-item :to="'/Alert'" index="2.3" icon="report_problem">
        Alert
      </vs-sidebar-item>
      <vs-sidebar-group open title="Energy Monitoring">
        <vs-sidebar-item :to="'/overview'" index="1" icon="cloud_queue">
          Overview
        </vs-sidebar-item>
        <vs-sidebar-item
          :to="'/demo/Energymonitoring/report'"
          index="2"
          icon="description"
        >
          Report
        </vs-sidebar-item>
        <vs-sidebar-item
          :to="'/demo/Energymonitoring/OverviewDashbooard'"
          index="3"
          icon="dashboard"
        >
          Overview Dashbooard
        </vs-sidebar-item></vs-sidebar-group
      >
      <vs-sidebar-item :to="'/FPSDashboardOverview'" index="3" icon="dashboard">
        Machine Monitoring
      </vs-sidebar-item>

      <vs-sidebar-item :to="'/demo/smartfarm'" index="3" icon="dashboard">
        Smart Farm
      </vs-sidebar-item>
      <vs-sidebar-item :to="'/demo/smartoffice'" index="3" icon="dashboard">
        Smart Office
      </vs-sidebar-item>
      <vs-sidebar-item :to="'/demo/workforce'" index="3" icon="dashboard">
        Workforce Management
      </vs-sidebar-item>
      <vs-sidebar-item :to="'/demo/data-center'" index="3" icon="dashboard">
        Data Control
      </vs-sidebar-item>
      <vs-sidebar-group open title="Inventory">
        <vs-sidebar-item
          v-for="i in sidebaritem"
          :key="i"
          :to="i.path"
          index="2.1"
        >
          <img
            style="width: 13.5%; height: 13.5%"
            src="@/assets/images/NikhomLatKrabang/3.png"
          />
          Station {{ i.id }}
        </vs-sidebar-item>
      </vs-sidebar-group>
      <vs-sidebar-group open title="Wastewater">
        <vs-sidebar-item
          v-for="i in sidebaritem"
          :key="i"
          :to="i.path"
          index="2.1"
        >
          <img
            style="width: 13.5%; height: 13.5%"
            src="@/assets/images/NikhomLatKrabang/3.png"
          />
          Station {{ i.id }}
        </vs-sidebar-item>
      </vs-sidebar-group>
      <vs-sidebar-group open title="Dashboard">
        <vs-sidebar-item :to="'/PlasticPaintingWWTPplant'" index="2.1">
          <img
            style="width: 13.5%; height: 13.5%"
            src="@/assets/sidebarIcon/42.png"
          />
          Plastic Painting WWTP
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/AluminiumPaintingWWTPplant'" index="2.1">
          <img
            style="width: 13.5%; height: 13.5%"
            src="@/assets/sidebarIcon/38.png"
          />
          Aluminium Painting WWTP
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/dafplant'" index="2.1">
          <img
            style="width: 13.5%; height: 13.5%"
            src="@/assets/sidebarIcon/40.png"
          />
          DAF Plant
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/centerplant'" index="2.1">
          <img
            style="width: 13.5%; height: 13.5%"
            src="@/assets/sidebarIcon/39.png"
          />
          Center Plant
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/asplant'" index="2.1">
          <img
            style="width: 13.5%; height: 13.5%"
            src="@/assets/sidebarIcon/52.png"
          />
          AS Plant
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/mbrplant'" index="2.1">
          <img
            style="width: 13.5%; height: 13.5%"
            src="@/assets/sidebarIcon/53.png"
          />
          MBR Plant
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/recycleplant'" index="2.1">
          <img
            style="width: 13.5%; height: 13.5%"
            src="@/assets/sidebarIcon/51.png"
          />
          Recycle Plant
        </vs-sidebar-item>

        <vs-sidebar-item :to="'/roplant'" index="2.1">
          <img
            style="width: 13.5%; height: 13.5%"
            src="@/assets/sidebarIcon/36.png"
          />
          RO Plant
        </vs-sidebar-item>
      </vs-sidebar-group>
      <vs-sidebar-group title="Device Mangement">
        <vs-sidebar-item :to="'/sensor'" index="2.2" icon="settings_remote">
          Device
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/gateway'" index="2.3" icon="router">
          Gateway
        </vs-sidebar-item>
      </vs-sidebar-group>
      <vs-sidebar-group title="Setting">
        <vs-sidebar-item :to="'/network'" index="2.2" icon="wifi">
          Network
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/action'" index="2.1" icon="new_releases">
          Alert Setting
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/user'" index="2.3" icon="person">
          User
        </vs-sidebar-item>
      </vs-sidebar-group>
    </vs-sidebar-group>

    <footer-sidebar slot="footer"> </footer-sidebar>
  </vs-sidebar>
</template>

<script>
import FooterSidebar from "../FooterSidebar.vue";
export default {
  name: "BetagroSidebar",
  components: {
    FooterSidebar,
  },
  data() {
    return {
      list_route: [
        "/overview",
        "/dataExport",
        "/EngineAssemblyLine",
        "/ConeveyerLine",
        "/BodyOutLine",
        "/sensor",
        "/gateway",
        "/network",
      ],
      sidebaritem: [
        {
          id: 3,
          path: "/Station03",
        },

        {
          id: 5,
          path: "/Station05",
        },
        {
          id: 6,
          path: "/Station06",
        },
        {
          id: 7,
          path: "/Station07",
        },

        {
          id: 9,
          path: "/Station09",
        },
        {
          id: 10,
          path: "/Station10",
        },
      ],
      interval: null,
      username: "",
    };
  },
  mounted() {
    this.username = this.$session.get("username");
  },
};
</script>

<style></style>
